import { inject, Injectable } from '@angular/core';
import { gungComparatorHelper } from 'gung-common';
import { ConfigBaseFilter, ConfigService, ListLayout, ListLayoutMultipleComponent, ListSortOption } from 'gung-list';
import { first, map, Observable } from 'rxjs';
import { UserDetailsCustomersTableComponent } from '../../components/users/user-details/user-details-customers/user-details-customers-table/user-details-customers-table.component';
import { CustomerService } from '../customers/customer.service';
import { Customer } from './../../models/customer';
import { GungStringConverterService } from '../../services/gung-string-converter.service';

@Injectable({
  providedIn: 'root'
})
export class UsersDetailsCustomersListConfigService implements ConfigService<Customer> {
  public customerService = inject(CustomerService);

  private isSelectedKey = 'isSelected';
  selectedCustomerIds: string[];

  setSelectedCustomerIds(selectedCustomerIds: string[]) {
    this.selectedCustomerIds = selectedCustomerIds.map(id => GungStringConverterService.toGungString(id));
  }

  getItems(): Observable<Customer[]> {
    return this.customerService.getCustomers().pipe(
      first(),
      map(customers => {
        for (const customer of customers) {
          customer[this.isSelectedKey] = this.selectedCustomerIds.includes(customer.id);
        }

        // first selected then unselected
        // for each group order by customer name
        const selectedCustomers = customers.filter(c => c[this.isSelectedKey]);
        selectedCustomers.sort((a, b) => gungComparatorHelper(a?.name?.toUpperCase(), b?.name?.toUpperCase(), 1));

        const unselectedCustomers = customers.filter(c => !c[this.isSelectedKey]);
        unselectedCustomers.sort((a, b) => gungComparatorHelper(a?.name?.toUpperCase(), b?.name?.toUpperCase(), 1));

        return selectedCustomers.concat(unselectedCustomers);
      })
    );
  }

  getFilters(): ConfigBaseFilter<Customer>[] {
    return [];
  }

  getSortOptions(): ListSortOption<Customer>[] {
    return [];
  }

  getBatchSizes(): number[] {
    const nemberCustomers = this.selectedCustomerIds.length;
    const batch = 5 + nemberCustomers;
    return [batch];
  }

  getSearchTerms(item: Customer): string[] {
    return [item.id, item.name];
  }

  getItemId(item: Customer): string {
    return item.id;
  }

  getLayouts(): ListLayout<Customer>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => UserDetailsCustomersTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'UserDetailsCustomerTable'
      }
    ];
  }

  getNothingFoundTranslateTag() {
    return 'NOTHING_FOUND';
  }
}
